import MfaMethodSelect from '@/components/PageSpecific/login/mfa/MfaMethodSelect';
import MfaOtpEntry from '@/components/PageSpecific/login/mfa/MfaOtpEntry';

export default function MfaStep({
  step,
  mfa,
  loadingStep,
  onMfaMethodContinue,
  onOtpSubmit,
  onResendOtp,
  onSelectDifferentMethod,
}) {
  if (step === 'mfa-method') {
    return (
      <MfaMethodSelect
        hasPhone={mfa.hasPhone}
        hasTotp={mfa.hasTotp}
        maskedEmail={mfa.maskedEmail}
        maskedPhone={mfa.maskedPhone}
        selectedMethod={mfa.selectedMethod}
        setSelectedMethod={mfa.setSelectedMethod}
        onContinue={onMfaMethodContinue}
        loading={loadingStep === 'mfa-method'}
      />
    );
  }

  if (step === 'mfa-otp') {
    return (
      <MfaOtpEntry
        onSubmit={onOtpSubmit}
        resendOtp={onResendOtp}
        loading={loadingStep === 'mfa-otp'}
        resendLoading={loadingStep === 'resend'}
        isVerifying={mfa.isVerifying}
        selectedMethod={mfa.selectedMethod}
        onSelectDifferentMethod={onSelectDifferentMethod}
      />
    );
  }

  return null;
}
